//import 'bootstrap/scss/bootstrap.scss'
// import 'bootstrap/dist/js/bootstrap'
// import 'bootstrap/scss/bootstrap.scss'
// import * as bootstrap from 'bootstrap'

import './custom.sass';
import { mount } from 'svelte';

import HeaderTop from './mock_blocks/HeaderTop.svelte';
import './hiddenScrolled';
import TopMenu from './mock_blocks/TopMenu.svelte';
import ModalMenu from './ModalMenu.svelte';
import FeedBackForm from './FeedBackForm.svelte';

import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

// console.log('app', document.querySelector('#landing-header-top'));

// const headerTopApp = mount(HeaderTop, {
// 	target: document.querySelector('#landing-header-top') as HTMLElement,
// 	props: {}
// });

document.querySelectorAll('.feedback-container').forEach((elContainer) => {
	const feedbackForm = mount(FeedBackForm, {
		target: elContainer,
		// anchor: document.querySelector('footer'),
		props: {}
	});
});

// const feedbackForm = mount(FeedBackForm, {
// 	target: document.querySelector('#feedback-container'),
// 	// anchor: document.querySelector('footer'),
// 	props: {}
// });

window.addEventListener('DOMContentLoaded', () => {
	// @ts-ignore
	const accordions = Array.from(document.querySelectorAll('.accordion-container'));
	new Accordion(accordions, {});
});
